<template>
    <header class="header">
        <div class="motor-container">
            <div class="motor-logo">
                <img :src="Logo" alt="logo">
                <div class="motor-logo_name">
                    myanmar motor <br> corporation
                </div>
            </div>
            <nav class="motor-nav" :class="{'open': toggle}">
                <div class="searchbar-container--mobile only-mobile">
                    <button class="button-search" @click="search"></button>
                    <input v-model="searchKey" @keyup="onKeyup" type="search">
                </div>
                <router-link to="/">home</router-link>
                <router-link to="/about">about us</router-link>
                <a type="button" class="dropdown" @click.self="isMenu = !isMenu" :class="{'router-link-exact-active': isWedo}">
                    <span @click.self="isMenu = !isMenu" :class="{'open': isMenu}">what we do</span>
                    <ul class="menu-list" :class="{'open': isMenu}">
                        <li>
                            <router-link to="/wedo/showroom/0">showroom</router-link>
                        </li>
                        <li>
                            <router-link to="/wedo/workshop">workshop</router-link>
                        </li>
                        <li>
                            <router-link to="/wedo/class">Training</router-link>
                        </li>
                        <li>
                            <router-link to="/wedo/production/0">production</router-link>
                        </li>
                    </ul>
                </a>
                <router-link to="/news">news</router-link>
                <router-link to="/contact">contact</router-link>
                <button class="motor-button--search" @click="goSearch" :class="{'is-search': isSearch}"></button>
            </nav>
            <button class="motor-menu" @click="toggle = !toggle">
                <div class="menu-icon" :class="{'open': toggle}"></div>
            </button>
        </div>
        <div class="motor-container motor-container--search" :class="{'search-close': !isSearch}">
            <div class="searchbar-container">
                <button class="button-search" @click="search"></button>
                <input class="input" v-model="searchKey" @keyup="onKeyup" type="search">
            </div>
        </div>
    </header>
</template>

<script>
import Logo from '@/assets/logo.png'

export default {
    name: 'motor-header',
    data() {
        return {
            Logo,
            toggle: false,
            isWedo: false,
            isMenu: false,
            isSearch: false,
            searchKey: '',
        }
    },
    watch: {
        '$route'(to, from) {
            this.isWedo = to.path.startsWith('/wedo')
            this.toggle = false
            this.isMenu = false
            if (to.name !== 'search') {
                this.isSearch = false
                this.searchKey = ''
            }else {
                this.isSearch = true
                this.searchKey = this.$route.params.key
            }
        }
    },
    methods: {
        goSearch() {
            if (this.isSearch) {
                this.isSearch = false
            } else {
                this.isSearch = true
                this.$el.querySelector('.input').focus()
            }
        },
        onKeyup({keyCode}) {
            if (keyCode === 13) this.search()
        },
        search() {
            const key = this.searchKey
            if (key) this.$router.push('/search/' + key)
        },
    },
    mounted() {
        // console.log(this.$route.path, 'init')
        // this.isWedo = this.$route.path.startsWidth('/wedo')
    }
}
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    height: var(--header-height);
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.1);
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;
    .motor-container {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .motor-logo {
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            img {
                width: 60px;
                @media (min-width: 768px) {
                    width: 80px;
                }    
            }
            .motor-logo_name {
                display: block;
                color: var(--primary);
                text-transform: uppercase;
                font-weight: 700;
                padding-left: 10px;
                @media (min-width: 768px) {
                    font-size: 1.2rem;
                }    
            }
        }
        .motor-nav {
            a {
                text-decoration: none;
                color: var(--body-color);
            }
            @media (max-width: 992px) {
                position: fixed;
                z-index: 9;
                top: 0;
                left: 0; 
                width: 100%;
                height: 100vw;
                background-color: var(--primary);
                opacity: 0;
                transform: translate(0, -100%) scale(0);
                border-radius: 100%;
                transition: all .3s ease;
                .only-mobile {
                    display: flex;
                }
                .searchbar-container--mobile {
                    max-width: calc(350px - 80px);
                    margin: 0 auto;
                    display: flex;
                    padding: 0;
                    justify-content: flex-start;
                    // background-color: #fffd;
                    // border-radius: 40px;
                    border-bottom: 2px solid #fffc;
                    input {
                        width: calc(100% - 32px);
                        border: none;
                        outline: none;
                        background-color: transparent;
                        color: #fff;
                        font-size: 1rem;
                        line-height: 1rem;
                    }
                    .button-search {
                        width: 32px;
                        height: 32px;
                        background-image: url(../assets/icons/search.svg);
                        background-repeat: no-repeat;
                        background-position: 4px 10px;
                        background-size: 16px;
                        filter: invert(100%);
                    }
                }
                a {
                    max-width: 350px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    flex-direction: column;
                    padding: 15px 40px;
                    font-size: 1.5rem;
                    color: #fff;
                    text-transform: uppercase;
                    transform: translate(0, -200px);
                    transition: transform .5s ease;
                    &.router-link-exact-active {
                        color: gold;
                    }
                    &.dropdown{
                        cursor: pointer;
                        span {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            pointer-events: none;
                            &::after {
                                content: '';
                                display: block;
                                width: 40px;
                                height: 40px;
                                background-image: url(../assets/icons/arrow-down.svg);
                                background-size: contain;
                                background-repeat: no-repeat;
                                background-position: center;
                                filter: invert(100%);
                                transition: transform .3s ease;
                            }
                            &.open::after {
                                transform: rotateX(180deg);
                            }
                        }
                        .menu-list {
                            list-style: none;
                            padding-left: 20px;
                            margin: 0;
                            transition: padding .3s ease;
                            a {
                                height: 0;
                                padding: 0;
                                opacity: 0;
                                overflow: hidden;
                                transition: padding .3s ease, opacity .3s ease;
                            }
                            &.open {
                                padding-top: 10px;
                                a {
                                    height: auto;
                                    padding: 15px;
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
                &.open {
                    padding-top: var(--header-height);
                    padding-bottom: var(--header-height);
                    opacity: 1;
                    height: 100%;
                    transform: translate(0, 0) scale(1);
                    overflow-y: auto;
                    border-radius: 0;
                    a {
                        transform: translate(0, 0);
                    }
                    // &::before {
                    //     opacity: 1;
                    //     transform: scale(1);
                    //     border-radius: 0;
                    // }
                }
            }
            @media (min-width: 991.9px) {
                height: 100%;
                display: flex;
                .only-mobile {
                    display: none;
                }
                a,
                .motor-button--search {
                    height: 100%;
                    padding: 0 25px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-top: 5px solid transparent;
                    border-bottom: 5px solid transparent;
                    text-transform: uppercase;
                    font-weight: 700;
                    font-size: 1.1rem;
                    position: relative;
                    &.dropdown{
                        padding-right: 10px;
                        cursor: pointer;
                        span {
                            display: flex;
                            justify-content: space-between;
                            &::after {
                                content: '';
                                display: block;
                                width: 24px;
                                height: 24px;
                                opacity: .8;
                                background-image: url(../assets/icons/arrow-down.svg);
                                background-size: contain;
                                background-repeat: no-repeat;
                                background-position: center;
                                transition: transform .3s ease;
                            }
                            &.open::after {
                                transform: rotateX(180deg);
                            }
                        }
                    }
                    .menu-list {
                        position: absolute;
                        z-index: 9;
                        top: calc(var(--header-height) - 20px);
                        left: -2px;
                        background-color: #fff;
                        box-shadow: 0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.1);
                        margin: 0;
                        min-width: 200px;
                        list-style: none;
                        border-radius: 10px;
                        padding: 10px 0;
                        transform: rotateX(-90deg);
                        opacity: 0;
                        transform-origin: 0 0;
                        transition: transform .3s ease, opacity .3s ease;
                        &.open {
                            transform: rotateX(0deg);
                            opacity: 1;
                        }
                        li {
                            a {
                                white-space: nowrap;
                                text-align: left;
                                justify-content: flex-start;
                                padding: 10px 30px;
                                &:hover {
                                    background-color: #f4f4f4;
                                }
                            }
                            .router-link-exact-active {
                                border-bottom: none;
                                color: var(--primary);
                            }
                        }
                    }
                }
                .router-link-exact-active {
                    border-bottom-color: var(--primary);
                }
                .motor-button--search {
                    width: 80px;
                    background-image: url(../assets/icons/search.svg);
                    background-size: 16px;
                    background-repeat: no-repeat;
                    background-position: center;
                }
            }
        }
        .motor-menu {
            position: fixed;
            z-index: 99;
            right: 10px;
            display: flex;
            width: 40px;
            height: 40px;
            // background-color: #eee;
            display: flex;
            justify-content: center;
            align-items: center;
            .menu-icon {
                width: 20px;
                height: 15px;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                align-items: center;
                background-color: var(--primary);
                &::before,
                &::after {
                    content: '';
                    display: block;
                    width: 100%;
                    height: 3px;
                    background-color: #fff;
                    transition: transform .3s ease;
                }
                &.open {
                    &::before {
                        transform: translate(0, 3px) rotate(45deg);
                    }
                    &::after {
                        transform: translate(0, -3px) rotate(-45deg);
                    }
                }
            }
            @media (min-width: 991.9px) {
                display: none;
            }    
        }
        &.motor-container--search {
            overflow: hidden;
            max-width: initial;
            transition: height .2s ease-in;
            background-color: #f4f4f4;
            .searchbar-container {
                margin: 0 auto;
                width: calc(100% - 20px);
                max-width: 600px;
                display: flex;
                justify-content: flex-start;
                border-bottom: 2px solid var(--primary);
                input {
                    width: calc(100% - 48px);
                    border: none;
                    outline: none;
                    background-color: transparent;
                    // font-size: 1.2rem;
                    color: #666;
                }
                .button-search {
                    width: 40px;
                    height: 40px;
                    background-image: url(../assets/icons/search.svg);
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: 16px;
                }
            }
        }
        &.search-close {
            height: 0;
        }
    }
}
</style>
